module.exports = __webpack_public_path__ + "static/media/Na_vinici.3dc27e67.md";